import ROLES from 'config/constants/ROLES';
import RolesPocketSafe from 'config/permissions/RolesPocketSafe';

/**
 * PocketSafe staff who manage global action templates (aligned with backend
 * is_pocketsafe_action_template_staff): Content Editor or Action Template Library Administrator.
 */
const isPocketSafeActionTemplateStaff = (psRoles: string[] | undefined): boolean => {
  if (!psRoles?.length) return false;
  return psRoles.includes(ROLES.PS_ROLES.CONTENT_EDITOR) || psRoles.includes(RolesPocketSafe.ActionLibraryAdministrator);
};

export default isPocketSafeActionTemplateStaff;
